module.exports = __webpack_public_path__ + "img/company3.4e3502ce.jpg";